var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCapsules(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M553.75 301.004L419.793 121.473C382.789 71.883 312.639 61.684 263.049 98.686C244.102 112.824 231.012 131.828 224 152.648V144C224 82.125 173.875 32 112 32S0 82.125 0 144V368C0 429.875 50.125 480 112 480S224 429.875 224 368V223.027C227.688 234.34 232.75 245.365 240.262 255.432L374.219 434.963C411.221 484.553 481.371 494.752 530.963 457.748C580.555 420.746 590.752 350.596 553.75 301.004ZM176 256H48V144C48 59.25 176 59.25 176 144V256ZM345.711 316.49L278.732 226.725C228.049 158.801 330.639 82.254 381.32 150.178L448.301 239.943L345.711 316.49Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapsules);
export default __webpack_public_path__ + "static/media/capsules.91857c3594e900275ff9e74d32ce62b2.svg";
export { ForwardRef as ReactComponent };